import React, { Component } from 'react'
import { css } from 'aphrodite'
import { connect } from '@cerebral/react'
import styles from './styles'
import { state, signal } from 'cerebral/tags'
import { NodeDragLayer } from './NodeDragLayer'
import { ContextMenu } from './ContextMenu'
import { TreeMenu } from './TreeMenu'
import { Common } from 'styles'
import { HiddenMenu } from 'components/Icons'

export default connect(
  {
    currentView: state`app.currentView`,
    isMenuOpen: state`node.tree.open`,
    isMenuHover: state`node.tree.hover`,
    inMenuTransition: state`node.tree.transition`,
    showTreeContextMenu: signal`node.showTreeContextMenu`,
    enterHoverTreeMenu: signal`node.enterHoverTreeMenu`,
    leaveHoverTreeMenu: signal`node.leaveHoverTreeMenu`
  },
  class Menu extends Component {
    onContextMenu(e, path) {
      e.preventDefault()
      e.stopPropagation()
      const { showTreeContextMenu } = this.props
      showTreeContextMenu({
        payload: {
          isVisible: true,
          position: { x: e.clientX, y: e.clientY },
          path,
          depth: 0
        }
      })
    }

    render() {
      const {
        isMenuOpen,
        isMenuHover,
        inMenuTransition,
        currentView,
        enterHoverTreeMenu,
        leaveHoverTreeMenu
      } = this.props

      if (currentView === 'startpage') {
        return null
      }

      let menuWidth =
        isMenuOpen || isMenuHover ? Common.treeWidth : Common.treeClosedWidth
      return (
        <nav
          style={{ width: menuWidth }}
          className={css(
            styles.menu,
            !isMenuOpen && !inMenuTransition ? styles.menuHover : null
          )}
          onContextMenu={e => this.onContextMenu(e, null)}
          onMouseEnter={e => {
            enterHoverTreeMenu()
          }}
          onMouseLeave={e => {
            leaveHoverTreeMenu()
          }}>
          <NodeDragLayer />
          <ContextMenu />
          <TreeMenu />
          {!isMenuHover && !isMenuOpen ? (
            <HiddenMenu
              style={{
                fill: 'rgba(0,0,0,0.27)',
                position: 'relative',
                width: 25,
                height: 25,
                left: 3,
                top: 2
              }}
            />
          ) : null}
        </nav>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Menu/menu.js